/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// React components
import { useContext, useEffect, useState } from "react";
import { ExperimentContext } from "context"

// @material-ui core components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import { Alert, Snackbar, TextField, Tooltip, Switch, Slider } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import FormControlLabel from "@mui/material/FormControlLabel";

// Settings page components
import FormField from "layouts/pages/account/components/FormField";

// Data
import selectData from "layouts/pages/account/settings/components/BasicInfo/data/selectData";

// Services
import AuthService from "services/auth-service";
import MDInput from "components/MDInput";

import { analytics } from "layouts/dashboards/analytics/analytics";
import { events } from "layouts/dashboards/analytics/events";
import { AuthContext } from "context";

function BasicInfo() {
   
  const { experimentationEnabled, toggleExperimentation } = useContext(ExperimentContext);
  const marks = [
    { value: 0, label: "Explore" },
    { value: 50, label: "Experience" },
    { value: 100, label: "Excel" },
  ];

  // const [value, setValue] = useState(0);
  const handleChange = (_, newValue) => {
    // setValue(newValue);
    setUser({ ...user, assessment_level: newValue });
  };
  const [user, setUser] = useState({
    education: [],
    email: [],
    experience: [],
    headline: "",
    linkedin_profile_id: "",
    preferred_jobs: [],
    preferred_locations: [],
    profile_image: "",
    skills: [],
    name: "",
    contact: "",
    organization: "",
    organization_role: "",
    assessment_level: 0
  });
  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });
  const [experimentationNotification, setExperimentationNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });
  const [errors, setErrors] = useState({
    nameError: false,
    headlineError: false,
    emailError: false,
    skillsError: false,
    preferredJobsError: false,
    preferredLocationsError: false,
    contactError: false,
    linkedinProfileIdError: false,
  });

  // Function to close the notification after 5 seconds
  useEffect(() => {
    if (notification.value === true) {
      let timer = setTimeout(() => {
        setNotification({ value: false, color: "info", message: "" });
      }, 5000);
    }
  }, [notification]);

  const experimentationHandler = async (e) => {
    toggleExperimentation(user.experimentation);
    // set new user data for call
    let userData = {
      data: {
        type: "profile",
        attributes: {
          email: user.email,
          experimentation: !user.experimentation
        },
      },
    };

    // call api for update
    try {
      await AuthService.updateExperimentation(JSON.stringify(userData));
    } catch (error) {
      setNotification({
        value: true,
        color: "error",
        message: "Something went wrong. Please try again later.",
      });
    }

    // reset errors
    setErrors({
      nameError: false,
      emailError: false,
    });

    // Show notification
    setExperimentationNotification({
      value: true,
      color: "info",
      message: "Experimentation Enabled",
    });
  };

  // Function to get the user's profile data
  useEffect(() => {
    (async () => {
      try {
        const response = await AuthService.getProfile();
        setUser((prevUser) => ({
          ...prevUser,
          experimentation: response.data.attributes.experimentation
        }));
      } catch (error) {
        setNotification({
          value: true,
          color: "error",
          message: "Something went wrong. Please try again later.",
        });
      }
    })();
  }, []);

  const { getCurrentUser } = useContext(AuthContext);

  // Function to handle the form submission
  const submitHandler = async (e) => {
    e.preventDefault();

    if (user.name.trim().length === 0) {
      // Check if the name is empty
      setErrors({ ...errors, nameError: true });
      return;
    }

    if (
      user.linkedin_profile_id &&
      user.linkedin_profile_id.trim().length !== 0
    ) {
      // Check if the linkedin profile id is in the correct format https://www.linkedin.com/in/<id>
      const linkedinProfileId = user.linkedin_profile_id;
      const linkedinProfileIdRegex =
        /^https:\/\/www.linkedin.com\/in\/[a-zA-Z0-9-]+$/;
      if (!linkedinProfileId.match(linkedinProfileIdRegex)) {
        setErrors({ ...errors, linkedinProfileIdError: true });
        return;
      }
    }

    if (user.contact.trim().length !== 0) {
      // Check if the contact is in the correct format
      const contact = user.contact;
      const contactRegex = /^\+?[0-9]*$/;
      if (!contact.match(contactRegex)) {
        setErrors({ ...errors, contactError: true });
        return;
      }
    }

    // if (user.headline.trim().length === 0) {
    //   // Check if the headline is empty
    //   setErrors({ ...errors, headlineError: true });
    //   return;
    // }

    // if (user.email.trim().length === 0) {
    //   // Check if the email is empty
    //   setErrors({ ...errors, emailError: true });
    //   return;
    // }

    // if (user.skills.length === 0) {
    //   // Check if the skills are empty
    //   setErrors({ ...errors, skillsError: true });
    //   return;
    // }

    // if (user.preferred_jobs.length === 0) {
    //   // Check if the preferred jobs are empty
    //   setErrors({ ...errors, preferredJobsError: true });
    //   return;
    // }

    // if (user.preferred_locations.length === 0) {
    //   // Check if the preferred locations are empty
    //   setErrors({ ...errors, preferredLocationsError: true });
    //   return;
    // }

    // set new user data for call
    let userData = {
      data: {
        type: "profile",
        attributes: {
          name: user.name,
          email: user.email,
          headline: user.headline,
          linkedin_profile_id: user.linkedin_profile_id,
          preferred_jobs: user.preferred_jobs,
          preferred_locations: user.preferred_locations,
          skills: user.skills,
          eduction: user.education,
          experience: user.experience,
          contact: user.contact,
          organization: user.organization,
          organization_role: user.organization_role,
          assessment_level: user.assessment_level,
        },
      },
    };

   

    // call api for update
    try {
      const user_id = await getCurrentUser();
      analytics.track(events.PROFILE_UPDATED, { userId: user_id });
      await AuthService.updateProfile(JSON.stringify(userData));
    } catch (error) {
      console.log(error);
      setNotification({
        value: true,
        color: "error",
        message: "Something went wrong. Please try again later.",
      });
    }

    // reset errors
    setErrors({
      nameError: false,
      emailError: false,
    });

    // Show notification
    setNotification({
      value: true,
      color: "info",
      message: "Your basic information has been updated",
    });
  };

  // Function to get the user's profile data
  useEffect(() => {
    (async () => {
      try {
        const response = await AuthService.getProfile();
        setUser((prevUser) => ({
          ...prevUser,
          education: response.data.attributes.education,
          email: response.data.attributes.email,
          experience: response.data.attributes.experience,
          headline: response.data.attributes.headline,
          linkedin_profile_id: response.data.attributes.linkedin_profile_id,
          preferred_jobs: response.data.attributes.preferred_jobs,
          preferred_locations: response.data.attributes.preferred_locations,
          profile_image: response.data.attributes.profile_image,
          skills: response.data.attributes.skills,
          name: response.data.attributes.name,
          contact: response.data.attributes.contact || "",
          organization: response.data.attributes.organization || "",
          organization_role: response.data.attributes.organization_role || "",
          assessment_level: response.data.attributes.assessment_level || 0,
        }));
      } catch (error) {
        console.log(error);
        setNotification({
          value: true,
          color: "error",
          message: "Something went wrong. Please try again later.",
        });
      }
    })();
  }, []);

  return (
    <>
      {notification.value === true && (
        <Snackbar open>
          <Alert variant="filled" sx={{ width: "100%" }} color="success">
            {notification.message}
          </Alert>
        </Snackbar>
      )}
      <Card id="basic-info" sx={{ overflow: "visible" }}>
        <MDBox p={3}>
          <MDTypography variant="h5">Basic Info</MDTypography>
        </MDBox>
        <MDBox
          component="form"
          pb={3}
          px={3}
          method="POST"
          onSubmit={submitHandler}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <FormField
                label="Full Name"
                value={user.name}
                variant="outlined"
                placeholder="Full Name"
                error={errors.nameError}
                onChange={(e) => {
                  setUser({ ...user, name: e.target.value });
                  setErrors({ ...errors, nameError: false });
                }}
              />
              {errors.nameError && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  Name cannot be empty
                </MDTypography>
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <Tooltip
                title="Email cannot be updated as it is linked to your account."
                placement="top"
              >
                <div style={{ display: "inline-block", width: "100%" }}>
                  <FormField
                    label="Email"
                    value={user.email}
                    variant="outlined"
                    placeholder="Email"
                    fullWidth
                    disabled
                  />
                </div>
              </Tooltip>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Contact"
                value={user.contact}
                fullWidth
                variant="outlined"
                placeholder="Contact"
                type="tel" // This specifies that the input is for a telephone number
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\+?[0-9]*$/.test(value)) {
                    setUser({ ...user, contact: value });
                    setErrors({ ...errors, contactError: false });
                  }
                }}
                inputProps={{
                  maxLength: 15, // Limit the length to a reasonable number for phone numbers
                }}
                helperText="Please include the country code. Example: +1234567890"
              />
              {errors.contactError && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  Please enter a valid contact number. Example: +1234567890
                </MDTypography>
              )}

              {/* // <FormField
              //   label="Contact"
              //   value={user.contact}
              //   placeholder="Contact"
              //   type="tel"
              //   onChange={(e) => 
              //     setUser({...user, contact: e.target.value })
              //   }
              // /> */}
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                label="LinkedIn Profile URL"
                variant="outlined"
                value={user.linkedin_profile_id}
                placeholder="LinkedIn Profile URL"
                onChange={(e) => {
                  setUser({ ...user, linkedin_profile_id: e.target.value });
                  setErrors({ ...errors, linkedinProfileIdError: false });
                }}
                helperText="Example: https://www.linkedin.com/in/<id>"
              />
              {errors.linkedinProfileIdError && (
                <MDTypography
                  variant="caption"
                  color="error"
                  fontWeight="light"
                >
                  Please enter a valid LinkedIn Profile ID. Example:{" "}
                  {"https://www.linkedin.com/in/<id>"}
                </MDTypography>
              )}
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormField
                label="Organization"
                variant="outlined"
                value={user.organization || ''}
                placeholder="Organization"
                onChange={(e) => setUser({ ...user, organization: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormField
                label="Organization Role"
                variant="outlined"
                value={user.organization_role || ''}
                placeholder="Organization Role"
                onChange={(e) => setUser({ ...user, organization_role: e.target.value })}
              />
            </Grid>
            {/* Uncomment once modal is implemented */}
            {/* <Grid item xs={12} sm={6} container alignItems="center" spacing={2} wrap="wrap">
              <Grid item xs={12} sm={4}>
                <MDTypography variant="h6">
                  Assessment Level
                </MDTypography>
              </Grid>

              <Grid item xs={12} sm={8}>
                <Slider
                  size="small"
                  value={user.assessment_level}
                  onChange={handleChange}
                  marks={marks}
                  step={null}
                  min={0}
                  max={100}
                  sx={{
                    width: "100%",
                    color: "#3f51b5",
                    "& .MuiSlider-markLabel": {
                      fontSize: "14px",
                      fontWeight: "bold",
                    },
                  }}
                />
              </Grid>
            </Grid> */}


          </Grid>
          <MDBox mt={3}>
            <FormControlLabel
              control={
                <Switch
                  checked={experimentationEnabled}
                  onChange={experimentationHandler}
                />
              }
              label="Experimental features"
            />
            <MDButton
              variant="gradient"
              color="success"
              size="small"
              type="submit"
              xs={12}
              onClick={submitHandler}
            >
              Update Profile
            </MDButton>
          </MDBox>
        </MDBox>

      </Card >
    </>
  );
}

export default BasicInfo;
